import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import shema from "../../../images/patients/karta_dostup.jpg";
import parkovka from "../../../images/patients/parkovka.jpg";

import data from "../../Data/accessibleEnvironment/accessibleEnvironmentData.json";

export default function AccessibleEnvironment() {
  useSEO(seoConfig.accessibleEnvironment);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Доступная среда
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        Ответственный за организацию помощи инвалидам В ГБУ СО "УрНИИДВиИ":
        <br></br>
        <br></br>Панюкова Свелана Леонидовна +7 (343) 218-89-55
      </h3>

      <p className="dissertation__text">
        Схема движения от остановок общественного транспорта
      </p>
      <img
        alt="Схема движения"
        className="clinicalbase__image"
        src={shema}
      ></img>
      <p className="dissertation__text">Парковка и пандус для инвалидов</p>
      <img
        alt="Схема движения"
        className="clinicalbase__image"
        src={parkovka}
      ></img>

      <p className="dissertation__text">
        На стоянке для автомобильного транспорта перед зданием учреждения у
        центрального входа есть места парковки для инвалидов.
        <br></br>
        <br></br>Въезд на стоянку свободный со стороны ул. Павлодарской.
        <br></br>
        <br></br>Вход в здание оборудован поручнями и имеет две двери.
        <br></br>
        <br></br>Входная дверь справа с табличкой «Для инвалидов» оборудована
        пандусом.
        <br></br>
        <br></br>Вызов охраны с вахты по тел. 218-33-72.
        <br></br>
        <br></br>На внутренней лестнице в фойе установлены поручни и подъемная
        платформа.
        <br></br>
        <br></br>Охрана, лифтер и администратор обучены оказанию помощи
        инвалидам.
        <br></br>
        <br></br>Приемы осуществляются на всех этажах учреждения.
        <br></br>
        <br></br>В требуемое подразделение для оказания медицинской помощи
        маломобильные граждане доставляются на грузопассажирском лифте.
        <br></br>
        <br></br>Туалет для инвалидов находится в поликлинике (цокольный этаж).
        <br></br>
        <br></br>В отделениях стационара имеются специально оборудованные палаты
        с ванными комнатами и туалетами.
        <br></br>
        <br></br>Для получения необходимой информации и оформления на прием к
        врачу или лечение в стационар нужно обратиться к администратору
        поликлиники.
        <br></br>
        <br></br>Шрифтом Брайля продублированы:
        <br></br>
        <br></br>- режим работы поликлиники на входной двери (слева);
        <br></br>
        <br></br>- наименования подразделений;
        <br></br>
        <br></br>- кабинеты руководителей.
      </p>

      <Accordion data={data} />
    </section>
  );
}
